module.exports = __webpack_public_path__ + "assets/import-blue.bff0a5cf.svg";